import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchForPipe } from './search-for-pipe';



@NgModule({
  declarations: [SearchForPipe],
  imports: [
    CommonModule
  ],
  exports: [
    SearchForPipe,
  ]
})
export class UtilityModule { }
